import { render } from "./ProjectsList.vue?vue&type=template&id=cecc6fb4"
import script from "./ProjectsList.vue?vue&type=script&lang=js"
export * from "./ProjectsList.vue?vue&type=script&lang=js"

import "./ProjectsList.vue?vue&type=style&index=0&id=cecc6fb4&lang=scss"

import exportComponent from "C:\\Users\\Riccardo\\Desktop\\vue-app\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__